import clsx from 'clsx'
import React, { BaseHTMLAttributes, CSSProperties, FC, PropsWithChildren } from 'react'

import { NavLinkClickProperties } from '@Analytics/ampli'
import { Link } from '@Components/Link'
import { Spinner } from '@Shared/Components/Spinner/Spinner'
import { StyleEx } from '@Shared/Utilities/CSSProperties/styleEx'

import styles from './Button.module.scss'

export interface ButtonProps {
  analytics?: NavLinkClickProperties
  className?: string
  disabled?: boolean
  fillWidth?: boolean
  href?: string
  id?: string
  innerSpacing?: 'none' | 'small' | 'medium' | 'large'
  loading?: boolean
  onClick?: BaseHTMLAttributes<HTMLElement>['onClick']
  onDoubleClick?: BaseHTMLAttributes<HTMLElement>['onDoubleClick']
  style?: CSSProperties
  theme?: 'black' | 'white' | 'primary' | 'label' | 'custom' | 'success' | 'transparent' | 'transparentWhite' | 'square'
  type?: 'submit' | 'reset' | 'button'
}

export const Button: FC<PropsWithChildren<ButtonProps>> = ({
  analytics,
  children,
  className,
  disabled,
  fillWidth,
  href,
  id,
  innerSpacing = 'small',
  loading,
  onClick,
  onDoubleClick,
  style,
  theme,
  type,
}) => {
  const exStyle = StyleEx(
    fillWidth && { width: '100%' },
    style,
  )
  const classList = clsx(
    styles.coreButton,
    loading && styles.loading,
    className,
    innerSpacing && styles[`space-${innerSpacing}`],
  )
  if (href) {
    return (
      <Link
        analytics={analytics}
        className={clsx(classList, styles[theme || 'label'])}
        href={href}
        id={id}
        onClick={onClick}
        onDoubleClick={onDoubleClick}
        style={exStyle}
      >
        {loading && <div className={styles.spinner}><Spinner /></div>}
        {children}
      </Link>
    )
  }
  if (onClick || type) {
    return (
      <button
        className={clsx(classList, styles[theme || 'black'])}
        disabled={disabled || loading}
        id={id}
        onClick={onClick}
        onDoubleClick={onDoubleClick}
        style={exStyle}
        // eslint-disable-next-line react/button-has-type
        type={type}
      >
        {loading && <div className={styles.spinner}><Spinner /></div>}
        {children}
      </button>
    )
  }
  return (
    <div
      className={clsx(classList, styles[theme || 'label'])}
      id={id}
      style={exStyle}
    >
      {loading && <div className={styles.spinner}><Spinner /></div>}
      {children}
    </div>
  )
}

